import { useMemo } from 'react';

import { theme, themeColors } from '~/theme';

export const useSxStyles = () => {
  return useMemo(() => {
    return {
      approvalStepsRoot: {
        '& .stepBox': {
          padding: theme.spacing(1),
          borderRadius: theme.spacing(0.5),
          backgroundColor: themeColors.background.grey,
          margin: theme.spacing(1, 0),
          '& .stepBoxTitle': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            minHeight: '34px',
            '& .relativeRole': {
              display: 'inline-block',
              fontSize: '0.7em',
              marginLeft: 1,
              backgroundColor: theme.palette.background.default,
              color: theme.palette.text.primary,
              borderRadius: '0.5em',
              padding: theme.spacing(0, 0.5),
              boxShadow: 1,

              '&.firstApprover': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
              },
              '&.finalApprover': {
                backgroundColor: theme.palette.success.main,
                color: theme.palette.success.contrastText,
              },
            },
          },
        },
      },
    };
  }, []);
};
